import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPerfIncome = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.875 2.6875V16.4375C2.875 16.9844 3.26562 17.375 3.8125 17.375H20.0625C20.5703 17.375 21 17.8047 21 18.3125C21 18.8594 20.5703 19.25 20.0625 19.25H3.8125C2.25 19.25 1 18 1 16.4375V2.6875C1 2.17969 1.39062 1.75 1.9375 1.75C2.44531 1.75 2.875 2.17969 2.875 2.6875ZM19.4766 7.10156L14.125 12.4141C13.7734 12.8047 13.1875 12.8047 12.8359 12.4141L9.75 9.32812L6.66406 12.4141C6.27344 12.8047 5.6875 12.8047 5.33594 12.4141C4.94531 12.0625 4.94531 11.4766 5.33594 11.125L9.08594 7.375C9.24219 7.17969 9.47656 7.10156 9.75 7.10156C9.98438 7.10156 10.2188 7.17969 10.4141 7.375L13.5 10.4609L18.1484 5.8125C18.5 5.42188 19.0859 5.42188 19.4766 5.8125C19.8281 6.16406 19.8281 6.75 19.4766 7.10156Z",
		fill: "#99B2F5"
	})]
});
const ForwardRef = forwardRef(SvgIconPerfIncome);
export { ForwardRef as ReactComponent };
